const currentDatetime = () => {
  const currentdate = new Date();
  const datetime = currentdate.getDate() + "/" +
    (currentdate.getMonth() + 1) + "/" +
    currentdate.getFullYear() + " @ " +
    currentdate.getHours() + ":" +
    currentdate.getMinutes() + ":" +
    currentdate.getSeconds();
  return datetime
};


window.disableTokenButtonClicked = (target) => {
  const url = $(target).data('url');
  $.ajax({
    url: url,
    type: 'PUT',
    data: {
      access_token: {
        inactivated_at: currentDatetime()
      }
    }
  });
};
